<template>
  <div>
    <b-modal
      id="modal-news-center"
      :hide-footer="true"
      modal-class="custom-modal2"
      content-class="rectangular-dark-blue-modal"
      @shown="onOpen"
      @hidden="onClose"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <div
          class="header-content w-100 d-inline-flex align-items-center justify-content-between"
        >
          <div class="headline">
            {{ $t("news.headline") }}
          </div>
          <div
            v-if="showUserNews && dataCommonNews.length > 0"
            class="ms-auto me-3"
          >
            <button class="button-red-outline" @click="deleteAllUpdates">
              {{ $t("news.delete_updates") }}
            </button>
          </div>
          <div
            v-else-if="!showUserNews && dataAnnouncements.length > 0"
            class="ms-auto me-3"
          >
            <button
              class="button-red-outline"
              @click="markAllAnnouncementsAsRead"
            >
              {{ $t("news.mark_as_read") }}
            </button>
          </div>
          <!-- TODO: once announcements have more types, extend filter (for now it's disabled in announcement view) -->
          <template v-if="showUserNews">
            <div
              v-if="filters.length > 1"
              class="filter-button bg-img clickable"
              :class="isFilterActive ? 'active' : 'inactive'"
              @click="showFilterMenu"
            ></div>
            <div v-if="filterOpen" class="filter-window">
              <div
                class="btn-close-filter clickable bg-img"
                @click="closeFilterMenu"
              ></div>
              <ul>
                <li
                  v-for="filter in filters"
                  :key="filter.title"
                  class="filter-entry clickable"
                  :class="[
                    filter.userNews ? 'green' : 'primary-accent',
                    filter.title === activeFilter ? 'active' : '',
                  ]"
                  @click="selectFilter(filter.title)"
                >
                  {{ $t(filter.title) }}
                </li>
              </ul>
            </div>
            <div class="filter-entry">{{ $t(activeFilter) }}</div>
            <div
              v-if="isFilterActive"
              class="filter-cancel-button clickable bg-img"
              @click="removeAllFilters"
            ></div>
          </template>
          <div v-if="showToggleButton" class="news-tabs">
            <div
              class="news-tab clickable"
              :class="{ active: !showUserNews }"
              @click="showUserNews && toggleView()"
            >
              News
            </div>
            <div
              class="news-tab clickable"
              :class="{ active: showUserNews }"
              @click="!showUserNews && toggleView()"
            >
              Updates
              <span v-if="dataCommonNews.length > 0" class="tab-count"
                >({{ dataCommonNews.length }})</span
              >
            </div>
          </div>

          <a href="#" class="close-button" @click="close()"> </a>
        </div>
      </template>

      <template slot="default">
        <b-row class="main-content">
          <b-col class="ms-3">
            <!-- announcements view -->
            <template v-if="!showUserNews && dataAnnouncements.length > 0">
              <AnnouncementEntry
                v-for="news in dataAnnouncements"
                :key="news.id"
                :entry="news"
            /></template>
            <!-- user news view -->
            <template v-else-if="showUserNews && dataCommonNews.length > 0">
              <div class="news-list container">
                <NewsListEntry
                  v-for="news in dataCommonNews"
                  :key="news.id"
                  :entry="news"
                /></div
            ></template>
            <!-- no news view -->
            <div v-else class="w-100 text-center mt-5 empty-state">
              <div class="empty-icon"></div>
              <span class="text-uppercase medium">
                {{ $t("news.no_news_placeholder") }}</span
              >
            </div>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import NewsListEntry from "@/components/notification/news-list-entry";
import AnnouncementEntry from "@/components/notification/announcement-entry";
export default {
  name: "ModalNewsCenter",
  components: { NewsListEntry, AnnouncementEntry },
  props: {},
  data() {
    return {
      filterOpen: false,
      error: false,
      activeFilter: "",
      showUserNews: false,
    };
  },

  computed: {
    filters() {
      return this.$store.getters["news/newsCategories"];
    },
    isFilterActive() {
      return this.activeFilter !== "";
    },
    showToggleButton() {
      return (
        this.dataAnnouncements.length > 0 || this.dataCommonNews.length > 0
      );
    },
    toggleButtonText() {
      return !this.showUserNews ? "Updates" : "News";
    },
    dataCommonNews() {
      let news = [...this.$store.state.news.userMessages].filter(Boolean); // copy to avoid mutating state

      if (this.activeFilter) {
        news = news.filter(
          (n) => n.news_type && n.news_type.title === this.activeFilter
        );
      }

      // Sort newest first
      news.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      return news;
    },

    dataAnnouncements() {
      const news = [...this.$store.state.news.messages];
      // Sort by priority (high prio first), then newest first
      news.sort((a, b) => {
        if ((b.priority || 0) !== (a.priority || 0)) {
          return (b.priority || 0) - (a.priority || 0);
        }
        return new Date(b.published_at) - new Date(a.published_at);
      });
      return news;
    },
    unreadAnnouncements() {
      const unread = this.$store.getters["news/unreadMessages"];
      return unread.some((msg) =>
        this.$store.state.news.messages.some((m) => m.id === msg.id)
      );
    },
    unreadUpdatesAvailable() {
      return this.$store.state.news.userMessages.some(
        (msg) =>
          !msg.seen_at &&
          !this.$store.state.news.readMessages.includes(msg.id) &&
          !this.$store.state.news.deletedMessages.includes(msg.id)
      );
    },
  },

  watch: {
    dataAnnouncements() {
      this.setDefaultView();
    },
    dataCommonNews() {
      this.setDefaultView();
    },
  },
  mounted() {
    this.setDefaultView();
  },

  methods: {
    showFilterMenu() {
      this.filterOpen = !this.filterOpen;
    },

    selectFilter(title) {
      this.activeFilter = title;
      this.closeFilterMenu();
    },
    closeFilterMenu() {
      this.filterOpen = false;
    },
    removeAllFilters() {
      this.activeFilter = "";
    },
    toggleView() {
      this.showUserNews = !this.showUserNews;
      this.activeFilter = "";
      this.filterOpen = false;
    },

    setDefaultView() {
      if (this.unreadUpdatesAvailable) {
        this.showUserNews = true;
      } else if (this.dataAnnouncements.length > 0) {
        this.showUserNews = false;
      } else if (this.dataCommonNews.length > 0) {
        this.showUserNews = true;
      } else {
        this.showUserNews = false;
      }
    },

    onOpen() {
      this.setDefaultView();
      this.dataCommonNews.forEach((news) => {
        this.$store.commit("news/markAsRead", news.id);
      });
      this.$store.dispatch("news/markUserNewsAsRead");
    },
    onClose() {
      if (this.$store.state.news.autoOpenNews) {
        this.$store.commit("news/setAutoOpenNewsCenter", false);
      }
    },
    async deleteAllUpdates() {
      await this.$store.dispatch("news/deleteAllUserNews");
    },
    async markAllAnnouncementsAsRead() {
      await this.$store.dispatch("news/markAllAnnouncementsAsRead");
    },
  },
};
</script>
<style lang="scss">
$modal-width: 1110px;
$modal-height: 700px;

#modal-news-center {
  .modal-dialog {
    max-width: $modal-width;
    width: 100%;
    height: $modal-height;
    top: 90px;

    @media (max-height: 700px) {
      transform: scale(0.8);
      top: 0;
    }
  }

  .modal-content {
    width: 100%;
    height: 100%;

    &.rectangular-dark-blue-modal {
      filter: drop-shadow(0 4px 30px rgba(77, 229, 255, 0.66))
        drop-shadow(0 4px 60px rgba(77, 229, 255, 0.66));
    }
  }
}
</style>
<style scoped lang="scss">
#modal-news-center {
  .button-red-outline {
    border: 1px solid #ff5555;
    color: #ff5555;
    background: transparent;
    padding: 6px 14px;
    border-radius: 4px;
    font-size: 12px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 85, 85, 0.2);
    }
  }
  .modal-header {
    .header-content {
      top: 0;
      padding-right: 100px;
      height: 60px;
      border-bottom: 1px solid rgba($text-accent, 0.25);

      .headline {
        font-family: Ubuntu-Medium;
        font-size: 36px;
        color: $primary-accent;
        text-transform: uppercase;
        text-shadow: 0 0 12px rgba($primary-accent, 0.5);
      }

      .news-tabs {
        display: inline-flex;
        margin-left: 16px;

        .news-tab {
          padding: 6px 20px;
          font-size: 14px;
          font-family: Ubuntu-Medium;
          text-transform: uppercase;
          color: rgba(255, 255, 255, 0.5);
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.06),
            rgba(255, 255, 255, 0.02)
          );
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.2s ease;

          &:first-child {
            border-radius: 4px 0 0 4px;
          }
          &:last-child {
            border-radius: 0 4px 4px 0;
            border-left: none;
          }

          &.active {
            color: #fff;
            background: linear-gradient(
              to bottom,
              rgba($primary-accent, 0.2),
              rgba($primary-accent, 0.08)
            );
            border-color: rgba($text-accent, 0.4);
            text-shadow: 0 0 8px rgba($primary-accent, 0.6);
          }

          .tab-count {
            font-family: Ubuntu;
            opacity: 0.7;
          }

          &:hover:not(.active) {
            color: rgba(255, 255, 255, 0.7);
            background: linear-gradient(
              to bottom,
              rgba(255, 255, 255, 0.1),
              rgba(255, 255, 255, 0.04)
            );
          }
        }
      }

      .filter-button {
        height: 60px;
        width: 60px;

        &.active {
          background-image: url(~@/assets/img/notification/icn-filter-menu-active.png);
        }

        &.inactive {
          background-image: url(~@/assets/img/notification/icn-filter-menu-inactive.png);
        }
      }

      .filter-window {
        position: absolute;
        left: 50%;
        z-index: 100;
        padding: 33px 20px 0 0;
        text-align: left;
        background-image: linear-gradient(#0e1c24, #173242);
        box-shadow: 0 2px 10px $drop-shadow-dark;
        border: 1px solid rgba($text-accent, 0.2);
        border-radius: 4px;
      }

      .filter-entry {
        font-size: 21px;
        font-family: Ubuntu;
        text-transform: uppercase;
        line-height: 2.6;
        cursor: pointer;
        white-space: nowrap;

        &.green {
          color: #43ff00;
        }

        &.active {
          color: #ffa900;
        }
      }

      .btn-close-filter {
        position: absolute;
        z-index: 100;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        background-image: url(~@/assets/img/notification/btn-filter-panel-close.svg);
      }

      .filter-cancel-button {
        height: 32px;
        width: 32px;
        background-image: url(~@/assets/img/notification/btn-close-filter.svg);
      }

      .close-button {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 40px;
        height: 40px;
        background: url(~@/assets/img/buttons/btn-close.svg) no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .main-content {
    flex: 1 1 auto;
    max-height: 550px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 1rem;

    &::-webkit-scrollbar {
      width: 10px;
      background: rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba($text-accent, 0.35);
      border-radius: 5px;

      &:hover {
        background: rgba($text-accent, 0.5);
      }
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
    }

    .news-list {
      width: 100%;
      padding-top: 8px;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .empty-icon {
      width: 64px;
      height: 64px;
      margin-bottom: 16px;
      background: url(~@/assets/img/notification/icn-nc-lobby.png) no-repeat
        center / contain;
      opacity: 0.3;
    }

    span {
      color: $text-gray;
      font-size: 16px;
    }
  }
}
</style>
